import Vue from 'vue'

export default {
	getByType({}, filter) {
		return Vue.api.post('card/list', {
			"per_page": filter.count || 10,
			"current_page": filter.page || 1,
			"type": filter.type,
			"worker_id": filter.worker,
			"user_id": filter.user
		})
	},
	get({}, id) {
		return Vue.api.get('card/' + id)
	},
	create({}, card) {
		let FD = convertToFormData(card)
		return Vue.api.post('card/', FD)
	},
	update(store, card) {
		if (!card._id) {
			return store.dispatch('create', card)
		}

		let FD = convertToFormData(card)
		return Vue.api.post('card/' + card._id, FD)
	},
	downloadFile(store, id) {
		return Vue.api.get('attachment/download/' + id)
	}
}

function convertToFormData(data) {
	let formData = new FormData()

	for (let key in data) {
		if (data.hasOwnProperty(key) && key !== '_id' && data[key] !== undefined)
			formData.append(key, data[key])
	}

	return formData
}



// WEBPACK FOOTER //
// ./src/vuex/services/card/actions.js